import * as React from "react";
const SvgCourseEmptyState = (props) => /* @__PURE__ */ React.createElement("svg", { width: 160, height: 128, viewBox: "0 0 160 128", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 52, y: 14, width: 68, height: 92, rx: 6, transform: "rotate(7 86 60)", style: {
  fill: "rgb(var(--landing-surface, 251 248 242))",
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 40, y: 12, width: 68, height: 96, rx: 6, style: {
  fill: "rgb(var(--landing-white, 255 255 255))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M92 12V38L99 32.5L106 38V12", style: {
  fill: "rgb(var(--landing-red, 192 57 43))",
  stroke: "rgb(var(--landing-red, 192 57 43))"
}, strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34 26H46M34 42H46M34 58H46M34 74H46M34 90H46", style: {
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M54 50H94M54 62H94M54 74H82M54 86H88", style: {
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M54 36H78", style: {
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2.5, strokeLinecap: "round" }));
export default SvgCourseEmptyState;
